import React, { Component } from 'react';
import without from 'lodash/without';
import { MAX_SELECTED_REVISIONS } from 'presentations/constants';
import Entries from 'presentations/containers/entries';

export default class EntryPickerField extends Component {
  constructor(props) {
    super(props);

    this.handleSelect = this.handleSelect.bind(this);
  }

  handleSelect(entry) {
    const selected = this.props.input.value || [];
    const revisionId = entry.revisions[0].id;

    /* remove revision from list if already present */
    if (selected.includes(revisionId)) {
      this.props.input.onChange(without(selected, revisionId));
    /* otherwise add it to list if maximum not yet reached */
    } else if (selected.length < MAX_SELECTED_REVISIONS) {
      this.props.input.onChange([ ...selected, revisionId ]);
    }
  }

  render() {
    return (
      <div className="entry-picker-field">
        <Entries onItemClick={this.handleSelect} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./presentations/components/entry_picker_field.jsx